import { notification } from 'antd';
import { all, call, put, take } from 'redux-saga/effects';
import * as moment from 'moment';
import update from 'immutability-helper';
import { history } from 'store';
import { BOOK_APPOINTMENT, UPDATE_BOOKING_INFO } from '../type';
import {
  bookAppointmentSuccessAction,
  bookAppointmentErrorAction,
  updateBookingInfoSuccessAction,
  updateBookingInfoErrorAction,
} from '../action';

import { bookingService, patientService, organisationService } from 'services';
import { Format } from 'common/enum';

function* bookAppointment() {
  while (1) {
    const action = yield take(BOOK_APPOINTMENT);

    try {
      //Upload signature first before book appointment
      const values = action.payload;
      //Data will be passed to book appointment
      const { generalCandidatePatientName, organisationId } = values;

      //Check patient appointment before create
      yield call(organisationService.validatePatient, {
        patientId: generalCandidatePatientName.key,
        organisationId,
      });

      const sampleCaseData = {
        patientId: generalCandidatePatientName.key,
        organisationId,
        caseProblemName: `AMC360`,
        dateInjury: moment(new Date()).toISOString(),
      };
      const caseInfo = yield call(
        patientService.createPatientCase,
        sampleCaseData,
      );

      //Update data to book appointment
      if (caseInfo) {
        const caseId = caseInfo.id;
        const caseName = `${sampleCaseData.caseProblemName} - ${moment().format(
          Format.Date,
        )}`;
        const updatedValues = update(values, {
          caseId: { $set: caseId },
          caseName: { $set: caseName },
        });
        //update patient
        const updatePatientParam = getUpdatePatientParam(updatedValues);
        yield call(patientService.updatePatientBilling, updatePatientParam);

        const bookedAppointment = yield call(
          bookingService.bookAppointmentAMC360,
          updatedValues,
        );
        if (bookedAppointment) {
          const consultation = yield call(
            bookingService.createConsultationAMC360,
            {
              organisationId,
              data: {
                appointmentID: bookedAppointment.appointmentId,
                appointmentUUID: bookedAppointment.appointmentUuid,
                patientID: generalCandidatePatientName.key,
                caseId,
              },
            },
          );
          if (consultation) {
            yield put(bookAppointmentSuccessAction(bookedAppointment));
            notification.success({
              message: 'New appointment has been successfully booked',
            });
            history.replace(
              `/manage-booking/amc360/${
                bookedAppointment.appointmentId
              }/organisation/${organisationId}`,
            );
          } else {
            notification.success({
              message: 'Failed to book new appointment',
            });
          }
        }
      }
    } catch (err) {
      notification.error({
        message: err.message || err.toString(),
      });
      yield put(bookAppointmentErrorAction(err));
    }
  }
}

function* updateBookingInfo() {
  while (1) {
    const action = yield take(UPDATE_BOOKING_INFO);
    try {
      const updatedBookingInfo = yield call(
        bookingService.updateBookingAMC360Info,
        action.payload,
      );

      yield put(updateBookingInfoSuccessAction(updatedBookingInfo));
      notification.success({
        message: 'This appointment has been successfully updated',
      });
      history.replace(`/manage-booking`);
    } catch (err) {
      notification.error({
        message: err.message,
      });
      yield put(updateBookingInfoErrorAction(err));
    }
  }
}

const getUpdatePatientParam = updatedValues => {
  return {
    patient: {
      id: updatedValues.generalCandidateId,
    },

    organisationId: updatedValues.organisationId,
    medicareNumber: updatedValues.generalMedicareNumber,
    medicareRefNumber: updatedValues.generalRefNumber,
    medicareExp: updatedValues.generalExpiryDate,
  };
};

export default function* rootSaga() {
  yield all([bookAppointment(), updateBookingInfo()]);
}
